import { axiosInstance } from ".";

export const getAllPrices = async (token, menu_id) => {
  try {
    const result = await axiosInstance.get(`admin/logistic/pricing/${menu_id}`);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getMenu = async (token) => {
  try {
    const result = await axiosInstance.get(`admin/logistic/group`);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};